import '../App.css';
import React, { useEffect, useState } from "react";
import Slider from '../components/slider.js';

const Home = () => {
  const [showText, setShowText] = useState(false);

  useEffect(() => {
    setTimeout(() => setShowText(true), 100);
  }, []);

  return (
    <div className="home-container">
        <div className='header'>
          <h1 
            className={`title ${showText ? "fade-in" : "hidden"}`}>Meck Interactive</h1>
          <p className={`subtitle ${showText ? "slide-up" : "hidden"}`}>Innovating the next era of gaming</p>
        </div>
        <div className={`body ${showText ? "fade-in" : "hidden"}`}>
            <Slider />
        </div>
        <div className={`footer ${showText ? "slide-up" : "hidden"}`}>
            <p className='contact'>Contact</p>
            <p 
              className='mail'
              onClick={() => window.location.href = "mailto:app@meck-int.com"}
              style={{ cursor: "pointer", textDecoration: "none" }}
              onMouseEnter={(e) => e.target.style.textDecoration = "underline"}
              onMouseLeave={(e) => e.target.style.textDecoration = "none"}
            >app@meck-int.com</p>
            <p className="privacy" onClick={() => window.location.pathname = "/privacy"}>Privacy Policy</p>
        </div>
    </div>
  );
};

export default Home;